import { render, staticRenderFns } from "./EnquiryForms.vue?vue&type=template&id=71a246d1&"
import script from "./EnquiryForms.vue?vue&type=script&lang=js&"
export * from "./EnquiryForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports